module.exports = __webpack_public_path__ + "static/img/check-mark.36490151.png";